import { Component, inject, OnDestroy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DialogService,
  DynamicDialogComponent,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import {
  ProductInterface,
  ProviderProductInterface,
  ProviderProductVariantInterface,
} from '../../../../core/interfaces/product/product';
import { ProviderProductsService } from '../../../../core/services/provider-products/provider-products.service';
import { ProviderProductDetailBaseComponent } from '../base/provider-product-detail-base.component';
import { DividerModule } from 'primeng/divider';
import {
  PriceSourceEnum,
  providerSettingsFunction,
  providerSettingsInterface,
} from '@component-library';
import { StoreService } from '../../../../core/store/store.service';
import { StoreInterface } from '../../../../core/interfaces/store/store-interface';
import { ProviderProductDetailMatchingComponent } from '../matching/provider-product-detail-matching.component';
import { ProviderProductDetailMarketplaceSpecialComponent } from '../marketplace-special/provider-product-detail-marketplace-special.component';
import {
  datasourceInterface,
  ProviderProductDetailVariantsComponent,
} from '../variants/provider-product-detail-variants.component';
import { ButtonModule } from 'primeng/button';
import { ProviderProductClass } from '../../../../core/classes/provider-product/provider-product';
import { TableModule } from 'primeng/table';
import { ProductClass } from '../../../../core/classes/product/product';
import { TooltipModule } from 'primeng/tooltip';
import { Subject, takeUntil } from 'rxjs';
import { VariantsInterface } from '../../../../core/interfaces/variants/variants-interface';
import { LocalStorageService } from '../../../../core/services/storage/local-storage.service';
import { Select } from 'primeng/select';
import { BroadcastChannelService } from '../../../../core/broadcast-channel/services/broadcast-channel.service';
import { RedisProviderCategoryAttributeRootInterface } from '../../../../core/interfaces/categories/provider-category-attributes-interface';
import { ProviderCategoryAttributesService } from '../../../../core/services/categories/provider-category-attributes.service';
import { providerAttributeEditFunction } from '../../functions/provider-attribute-edit-function';
import { prepareAttributes } from '../../functions/prepare-attributes-function';

export interface incorrectVariantMatchingDataSourceInterface
  extends ProviderProductVariantInterface {
  VariantKey: string;
  VariantValue: string;
}

@Component({
  selector: 'magenty-provider-product-detail-main',
  imports: [
    CommonModule,
    ProviderProductDetailBaseComponent,
    DividerModule,
    ProviderProductDetailMatchingComponent,
    ProviderProductDetailMarketplaceSpecialComponent,
    ProviderProductDetailVariantsComponent,
    ButtonModule,
    TableModule,
    TooltipModule,
    Select,
  ],
  templateUrl: './provider-product-detail-main.component.html',
  styleUrl: './provider-product-detail-main.component.scss',
})
export class ProviderProductDetailMainComponent implements OnDestroy {
  storeService = inject(StoreService);
  isSave = false;
  store: StoreInterface;
  providerProductService = inject(ProviderProductsService);
  tabStatus = 0;
  instance: DynamicDialogComponent | undefined;
  product: ProductInterface = new ProductClass(this.storeService.store$());
  providerProduct: ProviderProductInterface = new ProviderProductClass(
    this.storeService.store$()
  );
  providerSettings: providerSettingsInterface | undefined;
  showIncorrectVariantMatching = false;
  eachVariantAProduct: boolean | undefined = false;
  incorrectVariantMatchingDataSource: incorrectVariantMatchingDataSourceInterface[] =
    [];
  incorrectVariantMatchingList: {
    code: string;
    header: string;
    key: string;
    value: string;
  }[] = [];
  private destroy$ = new Subject<void>();
  /*  hbSku = '';
  isHbSku = false;*/
  newAttributes$ = signal(false);

  variantDataSource: datasourceInterface[] = [];
  baseVariants: VariantsInterface[] = [];

  matchingAutoComplete = signal({
    brand: false,
    category: false,
    attribute: false,
    variant: false,
  });

  providerCategoryAttributes = signal<
    RedisProviderCategoryAttributeRootInterface[]
  >([]);

  constructor(
    public ref: DynamicDialogRef,
    private dialogService: DialogService,
    private localStorageService: LocalStorageService,
    private broadcastChannelService: BroadcastChannelService,
    private providerCategoryAttributesService: ProviderCategoryAttributesService
  ) {
    broadcastChannelService.productDetailChannel.onmessage = () => {
      this.setProviderProduct(this.instance?.data);
    };

    this.store = this.storeService.store$();
    this.instance = this.dialogService.getInstance(this.ref);
    const instanceData = this.instance.data;

    if (instanceData) {
      /*
      this.isHbSku = instanceData.isHbSku;
      this.hbSku = instanceData.hbSku;*/

      this.providerSettings = providerSettingsFunction(
        instanceData.providerProduct.MarketplaceIdentity
      );
      this.setProviderProduct(instanceData);
    }
  }

  providerCategoriesAttributesRequest(providerCategory: string) {
    if (
      this.providerProduct &&
      this.providerProduct.ProviderId &&
      providerCategory.length > 0 &&
      this.providerProduct.Category !== 'MagentyNoCheck' &&
      this.providerSettings?.category.supporting
    ) {
      const request = {
        ProviderId: this.providerProduct.ProviderId,
        CategoryCode: providerCategory,
        MarketplaceIdentity: this.providerProduct.MarketplaceIdentity,
      };
      this.providerCategoryAttributesService
        .getList(request)
        .pipe(takeUntil(this.destroy$))
        .subscribe((attributeList) => {
          const tempAttributeList = [...attributeList];

          prepareAttributes(attributeList, this.providerProduct);

          this.providerProduct.Attributes = providerAttributeEditFunction(
            this.providerProduct.Attributes,
            attributeList
          );

          this.providerCategoryAttributes.set(tempAttributeList);
          this.checkAttributes();
          this.providerProduct.validationFunction(attributeList);
        });
    }
  }

  checkAttributes = () => {
    if (!this.providerProduct || this.providerProduct.Attributes.length === 0) {
      return;
    }

    this.providerProduct.Attributes.map((data) => {
      const foundAttributes = this.providerCategoryAttributes().find(
        (providerAttributes) => providerAttributes.Code === data.Code
      );
      if (
        foundAttributes &&
        foundAttributes.Values.length > 0 &&
        data.Value &&
        data.Value.length > 0
      ) {
        const found = foundAttributes.Values.find(
          (f) => f.Value.toLocaleLowerCase() === data.Value?.toLocaleLowerCase()
        );

        data.IsFaulty = !found;
      }
    });
  };

  /*  setHbSku = (isHbSku: boolean, hbSku: string) => {
    // Get Provider Product
    if (this.providerProduct.Id.length > 0) {
      this.providerProduct.Details.map((detail) => {
        if (detail.Key === 'HbSku' && detail.Value.length > 0) {
          this.hbSku = detail.Value;
        }
        if (detail.Key === 'KnowHbSku') {
          this.isHbSku = detail.Value === 'true';
        }
      });
    }

    // Get hepsiburada SKU Dialog
    else if (isHbSku && hbSku && hbSku.length > 0) {
      this.hbSku = hbSku;
      this.isHbSku = isHbSku;
    }

    this.providerSettings?.detailsFields.map((f) => {
      if (f.field === 'HbSku') {
        f.required = this.isHbSku;
        f.value = this.hbSku;
      }
      if (f.field === 'KnowHbSku') {
        f.value = this.isHbSku;
      }
    });
  };*/

  setProviderProduct = (instanceData: any) => {
    if (instanceData.providerProduct.Id.length > 0) {
      this.providerProductService
        .get(instanceData.providerProduct.Id)
        .pipe(takeUntil(this.destroy$))
        .subscribe((f) => {
          if (f && f.Status) {
            this.providerProduct = f.ProviderProduct;
            this.product = f.Product;

            this.incorrectVariantMatching();

            this.providerCategoriesAttributesRequest(
              this.providerProduct.Category
            );
            this.providerProduct.validationFunction();
          }
        });
    } else {
      if (instanceData.product && instanceData.providerProduct) {
        this.product = instanceData.product;
        this.providerProduct = instanceData.providerProduct;
        this.providerProduct.PriceSource = PriceSourceEnum.BasePrice;
      }

      if (this.providerProduct) {
        /*  this.setHbSku(this.isHbSku, this.hbSku);*/
        this.providerProduct.validationFunction();
      }
    }
  };

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.providerProduct.Id.length === 0 && !this.isSave) {
      const key = `${this.product.Id}-${this.providerProduct.MarketplaceIdentity}-${this.providerProduct.ProviderId}`;
      this.localStorageService.setItem(key, this.providerProduct);
    }
  }

  incorrectVariantMatchingValidation = () => {
    return this.providerProduct.Variants.some((variant) => {
      return !this.product?.VariantItems.find(
        (variantItem) => variantItem.Code === variant.VariantItemCode
      );
    });
  };
  incorrectVariantMatching = () => {
    if (this.product?.IsVariant && this.product.VariantItems.length > 0) {
      this.showIncorrectVariantMatching =
        this.incorrectVariantMatchingValidation();
      if (this.showIncorrectVariantMatching) {
        this.providerProduct.Variants.forEach((variant) => {
          const found = this.product?.VariantItems.find(
            (f) => f.Code === variant.VariantItemCode
          );
          if (!found) {
            const temp: incorrectVariantMatchingDataSourceInterface = {
              ...variant,
              VariantKey:
                variant.Details.find((f) => f.Key === 'VariantKey')?.Value ??
                '',
              VariantValue:
                variant.Details.find((f) => f.Key === 'VariantValue')?.Value ??
                '',
            };
            this.incorrectVariantMatchingDataSource.push(temp);
            this.product?.VariantItems.map((variant) => {
              variant.Values.map((f) => {
                const found = this.incorrectVariantMatchingList.find(
                  (x) =>
                    x.code === variant.Code &&
                    x.key === f.Key &&
                    x.value === f.Value
                );
                if (!found) {
                  this.incorrectVariantMatchingList.push({
                    code: variant.Code,
                    key: f.Key,
                    value: f.Value,
                    header: `${variant.Name} ${variant.Code} ${f.Key} ${f.Value}`,
                  });
                }
              });
            });
          }
        });
      }
    }
  };

  variantChange = (
    selectedVariant: incorrectVariantMatchingDataSourceInterface,
    event: any
  ) => {
    const found = this.providerProduct.Variants.find(
      (variant) =>
        variant.VariantItemCode === selectedVariant.VariantItemCode &&
        selectedVariant.VariantKey ===
          (variant.Details.find((f) => f.Key === 'VariantKey')?.Value ?? '') &&
        selectedVariant.VariantValue ===
          (variant.Details.find((f) => f.Key === 'VariantValue')?.Value ?? '')
    );
    if (found) {
      this.providerProduct.VariantCode = event.code;
      found.VariantItemCode = event.code;
      const varianteKey = found.Details.find((f) => f.Key === 'VariantKey');
      const varianteValue = found.Details.find((f) => f.Key === 'VariantValue');
      if (varianteKey) {
        varianteKey.Value = event.key;
      } else {
        found.Details.push({
          Key: 'VariantValue',
          Value: event.key,
        });
      }
      if (varianteValue) {
        varianteValue.Value = event.value;
      } else {
        found.Details.push({
          Key: 'VariantValue',
          Value: event.value,
        });
      }
      found.Name = '';
      found.NameId = '';
      found.Value = '';
      found.ValueId = '';
      this.providerProduct.validationFunction();
    }
  };
  variantSave = () => {
    this.showIncorrectVariantMatching =
      this.incorrectVariantMatchingValidation();

    this.providerProduct.validationFunction();
  };
  protected readonly history = history;
}
